import { FaCity, FaLink } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { WEBSITE_URL } from '../../services/api'
import { useState } from 'react'
import CookieBanner from '../components/CookieBanner'
import PopularPractices from '../components/PopularPractices'
import PopularCities from '../components/PopularCities'

function Footer() {
  const { t } = useTranslation()
  const [isCookieBannerOpen, setIsCookieBannerOpen] = useState(false)
  const links = {
    liensUtiles: {
      title: 'Liens utiles',
      items: [
        { name: t('private'), path: '/private' },
        { name: t('escort'), path: '/escort' },
        { name: t('massage'), path: '/massage' },
        { name: t('libertine'), path: '/libertins' },
        { name: t('search'), path: '/search' },
        { name: t('regions'), path: '/regions' },
        { name: t('popular'), path: '/popular' },
      ],
    },
    categories: {
      title: 'Catégories',
      items: [
        { name: 'Domination', path: '/domination' },
        { name: 'Escort girl', path: '/escort-girl' },
        { name: 'Étudiante', path: '/etudiante' },
        { name: 'Latina', path: '/latina' },
        { name: 'Maîtresse', path: '/maitresse' },
        { name: 'Mature', path: '/mature' },
        { name: 'Shemale', path: '/shemale' },
      ],
    },
    villesPopulaires: {
      title: 'Villes populaires',
      items: [
        {
          category: 'Domination',
          subcategories: [
            'Escort girl',
            'Étudiante',
            'Latina',
            'Maîtresse',
            'Mature',
            'Shemale',
            'Rencontres',
          ],
        },
        {
          category: 'Domination',
          subcategories: [
            'Escort girl',
            'Étudiante',
            'Latina',
            'Maîtresse',
            'Mature',
            'Shemale',
            'Rencontres',
          ],
        },
        {
          category: 'Domination',
          subcategories: [
            'Escort girl',
            'Étudiante',
            'Latina',
            'Maîtresse',
            'Mature',
            'Shemale',
            'Rencontres',
          ],
        },
      ],
    },
  }

  return (
    <>
      <footer className='w-full text-white bg-anthracite text-sm '>
        <div className='max-w-7xl xl:mx-auto mx-2'>
          <div className='flex flex-col lg:flex-row text-center xl:text-left xl:gap-8 pb-0 xl:pb-8'>
            <div className='lg:w-4/12'>
              <div className='bg-anthraciteLight p-7 text-center rounded-b-lg'>
                <Link
                  to='/'
                  onClick={() => {
                    window.scrollTo(0, 0)
                  }}
                >
                  <img
                    className='mb-3 w-40 mx-auto'
                    src='/images/logos/logo-sexagogo-redwhite.png'
                    alt='Logo Sexagogo'
                  />
                </Link>
                <h1
                  className='[&_a:hover]:underline'
                  dangerouslySetInnerHTML={{
                    __html: t('sexagogo-description', {
                      homeWebsite: `${WEBSITE_URL}`,
                    }),
                  }}
                ></h1>
              </div>
            </div>

            <div className='w-full md:flex md:flex-row md:gap-8 lg:w-4/12 xl:w-6/12'>
              <div className='w-full md:w-1/2 pt-5'>
                <h3 className='text-base flex font-semibold mb-4 pb-2 border-b-2 border-redpink text-white justify-center xl:justify-start'>
                  <FaLink className='mr-3 text-xl text-redpink' />
                  <span className='block'>{links.liensUtiles.title}</span>
                </h3>
                <ul className='space-y-0'>
                  {links.liensUtiles.items.map(item => (
                    <li key={item.name}>
                      <Link
                        to={item.path}
                        onClick={() => {
                          window.scrollTo(0, 0)
                        }}
                        className='text-gray-300 block rounded py-1 hover:text-redpink hover:pl-2 hover:bg-anthraciteLight transition-all'
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className='w-full md:w-1/2 pt-5'>
                <PopularPractices />
              </div>
            </div>

            <PopularCities />
          </div>
        </div>
        <div className='bg-anthraciteLight py-4 mt-5 xl:mt-0 w-full min-h-40px pb-16 lg:pb-4'>
          <div className='max-w-7xl mx-auto px-4 flex flex-wrap justify-between items-center gap-2 text-sm text-grisclair'>
            <Link
              to='/'
              onClick={() => {
                window.scrollTo(0, 0)
              }}
              className='w-full sm:w-auto text-center'
            >
              <img
                className='w-11 mx-auto'
                src='/images/logos/logo-sexagogo-redwhite.png'
                alt='Logo Sexagogo'
              />
            </Link>

            <Link
              to='/asbl/'
              onClick={() => {
                window.scrollTo(0, 0)
              }}
              className='hover:text-redpink transition-all w-full sm:w-auto text-center'
            >
              {t('help-centers')}
            </Link>
            <Link
              to='/terms-of-use/'
              onClick={() => {
                window.scrollTo(0, 0)
              }}
              className='hover:text-redpink transition-all w-full sm:w-auto text-center'
            >
              {t('terms-of-use')}
            </Link>
            <Link
              to='/privacy/'
              onClick={() => {
                window.scrollTo(0, 0)
              }}
              className='hover:text-redpink transition-all w-full sm:w-auto text-center'
            >
              {t('privacy')}
            </Link>
            <Link
              to='/cookies/'
              onClick={() => {
                window.scrollTo(0, 0)
              }}
              className='hover:text-redpink transition-all w-full sm:w-auto text-center'
            >
              {t('cookies-link')}
            </Link>
            <button
              onClick={() => setIsCookieBannerOpen(true)}
              className='hover:text-redpink transition-all w-full sm:w-auto text-center'
            >
              {t('cookies-param')}
            </button>
            <Link
              to='/help/'
              onClick={() => {
                window.scrollTo(0, 0)
              }}
              className='hover:text-redpink transition-all w-full sm:w-auto text-center'
            >
              {t('help')}
            </Link>

            <Link
              to='/contact/'
              onClick={() => {
                window.scrollTo(0, 0)
              }}
              className='hover:text-redpink transition-all w-full sm:w-auto text-center'
            >
              {t('contact')}
            </Link>
          </div>
        </div>
      </footer>
      <CookieBanner
        isOpen={isCookieBannerOpen}
        onClose={() => setIsCookieBannerOpen(false)}
      />
    </>
  )
}

export default Footer
